import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetTripSuggestionOutput, TripAutocompleteInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/** En deçà, la recherche renverrait trop de bruit pour être utile. */
export const MIN_AUTOCOMPLETE_LENGTH = 2;

const DEFAULT_LIMIT = 8;

/**
 * `GET /v1/trips/autocomplete` — courses proposées à la sélection avant la
 * création d'une réclamation. Le back cherche sur l'ID Allocab, l'ID externe et
 * le nom du passager.
 *
 * Volontairement **sans période ni périmètre du header** : l'API restreint déjà
 * au compte et au périmètre de l'appelant, et une réclamation porte souvent sur
 * une course hors du filtre affiché. Y appliquer les filtres du header ferait
 * disparaître des courses que l'utilisateur a pourtant le droit de désigner.
 */
export const useTripAutocomplete = (search: string, limit = DEFAULT_LIMIT) => {
  const term = search.trim();
  return useQuery<ListOutput<ExtranetTripSuggestionOutput>>({
    queryKey: extranetQueryKeys.rides.autocomplete(term, limit),
    queryFn: () =>
      getExtranetApi().get<TripAutocompleteInput, ListOutput<ExtranetTripSuggestionOutput>>('/v1/trips/autocomplete', {
        search: term,
        limit,
      }),
    enabled: term.length >= MIN_AUTOCOMPLETE_LENGTH,
    placeholderData: keepPreviousData,
  });
};
